<template>
  <div class="row">
    <div class="col-12 mb-4 d-flex justify-content-between align-items-center flex-wrap">
      <div>
        <h3 class="text-white font-weight-bold mb-1">
          <i class="mdi mdi-account-circle-outline text-primary mr-2"></i>
          {{ $t('profile.title') }}
        </h3>
        <p class="text-muted small mb-0">
          {{ $t('profile.subtitle') }}
        </p>
      </div>
    </div>

    <div class="col-12 grid-margin">
      <div class="card border border-subtle">
        <div class="card-body p-4">
          <div class="d-flex flex-column flex-md-row align-items-md-center pb-4 mb-4 border-bottom border-subtle">
            <img
              :src="user.profile_picture_path || (user.profile_picture ? config.STORAGE_URL + user.profile_picture : require('../assets/images/faces/default.jpg'))"
              alt="Profile Avatar"
              class="rounded-circle mr-md-4 mb-3 mb-md-0"
              style="width: 88px; height: 88px; object-fit: cover; border: 2px solid rgba(99, 102, 241, 0.5);"
            />
            <div>
              <h4 class="text-white font-weight-bold mb-1">{{ user.name || '-' }}</h4>
              <span class="badge badge-outline-info px-3 py-1">
                {{ displayRole || ($currentLocale === 'id' ? 'Anggota Organisasi' : 'Enterprise Member') }}
              </span>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6 mb-3">
              <label class="text-muted small text-uppercase font-weight-bold d-block mb-1">{{ $t('common.name') }}</label>
              <div class="text-white font-weight-medium py-1">{{ user.name || '-' }}</div>
            </div>
            <div class="col-md-6 mb-3">
              <label class="text-muted small text-uppercase font-weight-bold d-block mb-1">{{ $t('common.role') }}</label>
              <div class="text-white font-weight-medium py-1">{{ displayRole || '-' }}</div>
            </div>
            <div class="col-md-6 mb-3">
              <label class="text-muted small text-uppercase font-weight-bold d-block mb-1">{{ $t('profile.emailAddress') }}</label>
              <div class="text-white font-weight-medium py-1">{{ user.email || '-' }}</div>
            </div>
            <div class="col-md-6 mb-3">
              <label class="text-muted small text-uppercase font-weight-bold d-block mb-1">{{ $t('profile.phoneNumber') }}</label>
              <div class="text-white font-weight-medium py-1">{{ user.phone_number || '-' }}</div>
            </div>
          </div>

          <div class="d-flex flex-wrap gap-2 mt-4 pt-3 border-top border-subtle">
            <button
              type="button"
              @click="back"
              class="btn btn-outline-secondary btn-icon-text px-4 py-2 mr-2"
            >
              <i class="mdi mdi-arrow-left mr-1"></i>
              {{ $t('common.back') }}
            </button>
            <router-link
              :to="{ name: 'ProfileEdit' }"
              class="btn btn-primary btn-icon-text px-4 py-2 mr-2 font-weight-bold"
            >
              <i class="mdi mdi-lead-pencil mr-1"></i>
              {{ $t('common.edit') }}
            </router-link>
            <router-link
              :to="{ name: 'ProfileEditPassword' }"
              class="btn btn-outline-warning btn-icon-text px-4 py-2"
            >
              <i class="mdi mdi-lock-reset mr-1"></i>
              {{ $t('profile.resetPasswordTitle') }}
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script>
  import moment from 'moment';
  import { getProfile } from '@/services/authService';
  import config from '@/config/config';
  import store from '@/store';
  
  export default {
    data() {
      let resolvedId = null;
      try {
        const raw = store.state.user || localStorage.getItem('user');
        let parsed = typeof raw === 'string' ? JSON.parse(raw) : raw;
        if (typeof parsed === 'string') parsed = JSON.parse(parsed);
        resolvedId = parsed?.data?.id || parsed?.id || null;
      } catch (e) {
        resolvedId = null;
      }

      return {
        user: {},
        id: resolvedId,
        config
      }
    },
    computed: {
      displayRole() {
        if (!this.user || !this.user.role) return '';
        return this.user.role.split(',').map(r => r.trim().charAt(0).toUpperCase() + r.trim().slice(1)).join(', ');
      }
    },
    mounted() {
      if (this.id) {
        this.fetchDetailUser();
      }
    },
    methods: {
      fetchDetailUser() {
        if (!this.id) return;
        getProfile(this.id).then(response => {
          this.user = response.data || {};
        });
      },
      formatDate(date) {
        return moment(date).format('DD MMMM YYYY');
      },
      back() {
        this.$router.go(-1);
      },
    },
  };
  </script>
  
  